<template>
    <date-picker
        type="time"
        v-model="date"
        format='HH:mm'
        display-format="HH:mm"
        class="p-pay-representation-time-select-left"
    />
</template>

<script>

export default {
  data () {
    return {
      date: ''
    }
  },
  watch: {
    date (date) {
      this.$emit('selectedDate', date)
    }
  }
}
</script>
